import DosRejectedComment from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    default:
      return [key, val];
  }
};

const create = (data) => new DosRejectedComment(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/DosRejectedComment/create.js